import React from "react";
import fields from "../../json/GrandLoan.json";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormTextarea from "Common/Custom/FormTextarea";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import { getSelectOptions } from "utils/optionHelper";

const statusOptions = [
  { value: "1", label: "Granted" },
  { value: "2", label: "Deny" },
];

const EditGrandLoanForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  employeeOptions,
}) => {
  const { formdata } = fields;

  const optionConfig = {
    employee_id: {
      list: employeeOptions,
      valueKey: "employee_id",
      labelKey: "employee_name",
    },
    permitted_by: {
      list: employeeOptions,
      valueKey: "employee_id",
      labelKey: "employee_name",
    },
    status: {
      list: statusOptions,
      valueKey: "value",
      labelKey: "label",
    },
  };

  const renderField = (field) => {
    if (
      field.type === "select" &&
      ["employee_id", "permitted_by", "status"].includes(field.name)
    ) {
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          options={getSelectOptions(field.name, optionConfig)}
          error={errors[field.name]}
        />
      );
    }

    if (field.type === "textarea") {
      return (
        <FormTextarea
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      );
    }

    if (field.type === "date") {
      return (
        <FormDatePicker
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
          mode="date"
          required={field.required}
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name]}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Edit Grant Loan</HeadingOne>}
    >
      {formdata.map((field) => renderField(field))}

      <FormSubmitButton
        label="Update Loan"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditGrandLoanForm;
